/* eslint-disable react-hooks/exhaustive-deps */
import { Search, RotateCw, Copy } from 'lucide-react'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Row,
  Table
} from 'react-bootstrap'
import { AsyncTypeahead } from 'react-bootstrap-typeahead'
import { useNavigate } from 'react-router-dom'
import Select from 'react-select'
import Loader from '../../../components/atoms/Loader'
import { BadgeStatusPrListInbounds } from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import api from '../../../config/AxiosInstance'
import { convertDateWithoutTime } from '../../../helpers/constants'
import '../../../styles/style.css'
import * as Common from '../../../utils/Common'
import toast, { Toaster } from 'react-hot-toast'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

const SJ = () => {
  const [loading, setLoading] = useState(false)
  const [sjList, setSjList] = useState([])
  const handleCopy = (text) => {
    navigator.clipboard.writeText(text)
    toast.success('Copied to clipboard')
  }
  const [sjDraftId, setSjDraftId] = useState('')
  const [debouncedSjDraftId, setDebouncedSjDraftId] = useState('')
  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })
  const [inputCustomer, setInputCustomer] = useState('')
  const [inputSrcWarehouse, setInputSrcWarehouse] = useState(null)
  const [inputSo, setInputSo] = useState('')
  const [debouncedInputSo, setDebouncedInputSo] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [warehouses, setWarehouses] = useState([])
  const { per_page, current_page } = meta

  const refCustomer = useRef(AsyncTypeahead)
  const refSrcWarehouses = useRef()

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSjDraftId(sjDraftId)
      setDebouncedInputSo(inputSo)
      if (sjDraftId !== debouncedSjDraftId || inputSo !== debouncedInputSo) {
        setMeta((prev) => ({ ...prev, current_page: 1 }))
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [sjDraftId, inputSo])

  useEffect(() => {
    fetchSjList()
    if (!warehouses.length) {
      fetchWarehouse()
    }
  }, [
    per_page,
    current_page,
    debouncedSjDraftId,
    debouncedInputSo,
    inputCustomer,
    inputSrcWarehouse,
    startDate,
    endDate
  ])

  const fetchSjList = async () => {
    try {
      setLoading(true)
      const res = await api.get('/outbound/sjdraft', {
        params: {
          per_page,
          page: current_page,
          sj_draft: debouncedSjDraftId || '',
          so: debouncedInputSo || '',
          customer: inputCustomer || '',
          src: inputSrcWarehouse || '',
          start_date: startDate || '',
          end_date: endDate || ''
        }
      })
      const { metadata, data } = res.data
      setSjList(data)
      setMeta(metadata)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    } finally {
      setLoading(false)
    }
  }

  function handleOnChangeMeta(e) {
    const perPageValue = parseInt(e.target.value, 10)
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: perPageValue,
      current_page: 1
    }))
  }

  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: parseInt(data.selected + 1)
    }))
    window.scrollTo(0, 0)
  }

  const navigate = useNavigate()
  const navigateToDetail = (data) => {
    const encodedName = encodeURIComponent(data.sj_draft)
    navigate(`/outbound/sj/detail/${encodedName}`)
  }

  function handleReset() {
    refCustomer.current?.clear()
    refSrcWarehouses.current?.clearValue()
    setInputCustomer('')
    setInputSrcWarehouse(null)
    setInputSo('')
    setSjDraftId('')
    setDebouncedInputSo('')
    setDebouncedSjDraftId('')
    setStartDate('')
    setEndDate('')
    setMeta((meta) => ({
      ...meta,
      per_page: 10,
      current_page: 1
    }))
  }

  const filterCustomer = () => true
  const [isLoadingCustomer, setLoadingCustomer] = useState(false)
  const [optionsCustomer, setOptionsCustomer] = useState([])
  async function handleSearchCustomer(query) {
    setLoadingCustomer(true)
    try {
      const params = `?q=${query}`
      const res = await api.get(`erp/sales-order/all-customer/${params}`)
      setOptionsCustomer(res.data.data)
      setLoadingCustomer(false)
    } catch (err) {
      setLoadingCustomer(false)
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const fetchWarehouse = async () => {
    try {
      const params = {
        is_parent: 1,
        forUser: 1
      }
      const response = await api.get('/master/warehouses/all', { params })
      const { data } = response.data
      setWarehouses(data)
    } catch (err) {
      const errMsg = err?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  return (
    <>
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3 style={headerTitleStyle}>SJ Draft List</h3>
              <Button
                variant="light"
                className="text-secondary fw-bold rounded px-3 border"
                onClick={handleReset}
                style={{ fontSize: '0.85rem' }}
              >
                <RotateCw size={16} className="me-2" />
                Reset Filters
              </Button>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>#SJ DRAFT</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="sj_draft"
                    id="sj_draft"
                    placeholder="Search SJ Draft..."
                    onChange={(e) => setSjDraftId(e.target.value)}
                    value={sjDraftId}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>#SO</Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    name="so"
                    id="so"
                    placeholder="Search SO..."
                    onChange={(e) => setInputSo(e.target.value)}
                    value={inputSo}
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>CUSTOMER</Form.Label>
                <AsyncTypeahead
                  id="basic-typeahead-single"
                  labelKey="customer"
                  isLoading={isLoadingCustomer}
                  filterBy={filterCustomer}
                  onSearch={handleSearchCustomer}
                  onChange={(e) => {
                    setInputCustomer(e.length > 0 ? e[0].customer : '')
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={optionsCustomer}
                  placeholder="Choose a customer ..."
                  ref={refCustomer}
                  inputProps={{
                    style: { ...FormControlStyle }
                  }}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>SOURCE WAREHOUSE</Form.Label>
                <Select
                  isClearable
                  id="warehouse"
                  styles={SelectStyles}
                  onChange={(e) => {
                    setInputSrcWarehouse(e ? e.value : null)
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={warehouses.map((warehouse) => ({
                    value: warehouse.id,
                    label: warehouse.warehouse_name
                  }))}
                  placeholder="Select Warehouse"
                  ref={refSrcWarehouses}
                  value={
                    inputSrcWarehouse
                      ? {
                          value: inputSrcWarehouse,
                          label: warehouses.find(
                            (w) => w.id === inputSrcWarehouse
                          )?.warehouse_name
                        }
                      : null
                  }
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={startDate}
                    onChange={(date) => {
                      const newDate = date
                        ? moment(date).format('YYYY-MM-DD')
                        : ''
                      setStartDate(newDate)
                      if (
                        newDate &&
                        endDate &&
                        moment(newDate) > moment(endDate)
                      ) {
                        setEndDate(newDate)
                      }
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    maxDate={endDate ? new Date(endDate) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={endDate}
                    onChange={(date) => {
                      const newDate = date
                        ? moment(date).format('YYYY-MM-DD')
                        : ''
                      setEndDate(newDate)
                      if (
                        startDate &&
                        newDate &&
                        moment(newDate) < moment(startDate)
                      ) {
                        setStartDate(newDate)
                      }
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    minDate={startDate ? new Date(startDate) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-3">
          <Col md={12}>
            <Table
              hover
              size="sm"
              responsive
              className="shadow-sm mb-5 bg-white"
              style={{
                borderRadius: '12px',
                overflow: 'hidden',
                fontSize: '0.9rem'
              }}
            >
              <thead style={{ backgroundColor: '#f8f9fa' }}>
                <tr>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #SJ DRAFT
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    #SO
                  </th>
                  <th className="p-2 align-middle" style={tableHeaderStyle}>
                    Customer
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={{ ...tableHeaderStyle, width: '15%' }}
                  >
                    Source Warehouse
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    #Outbound
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Status
                  </th>
                  <th
                    className="p-2 align-middle text-end"
                    style={tableHeaderStyle}
                  >
                    Delivery Date
                  </th>
                  <th
                    className="p-2 text-end"
                    style={{ ...tableHeaderStyle, width: '10%' }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody style={{ fontSize: '13px' }}>
                {loading && (
                  <tr>
                    <td colSpan={9} className="text-center p-5">
                      <Loader />
                    </td>
                  </tr>
                )}
                {!loading && sjList.length === 0 && (
                  <tr>
                    <td
                      colSpan={9}
                      className="fw-bold text-center p-5 text-muted"
                    >
                      No Data Found
                    </td>
                  </tr>
                )}
                {!loading &&
                  sjList.length > 0 &&
                  sjList?.map((data, i) => (
                    <tr key={i} style={{ borderBottom: '1px solid #f0f0f0' }}>
                      <td className="p-2 align-middle fw-semibold text-primary">
                        <div className="d-flex align-items-center gap-2">
                          {data.sj_draft}
                          <Copy
                            size={14}
                            className="text-muted cursor-pointer"
                            style={{
                              cursor: 'pointer',
                              opacity: 0.5,
                              transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.opacity = 1)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.opacity = 0.5)
                            }
                            onClick={() => handleCopy(data.sj_draft)}
                            title="Copy SJ Number"
                          />
                        </div>
                      </td>
                      <td className="p-2 align-middle">
                        <div className="d-flex align-items-center gap-2">
                          {data.so}
                          <Copy
                            size={14}
                            className="text-muted cursor-pointer"
                            style={{
                              cursor: 'pointer',
                              opacity: 0.5,
                              transition: 'opacity 0.2s'
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.opacity = 1)
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.opacity = 0.5)
                            }
                            onClick={() => handleCopy(data.so)}
                            title="Copy SO Number"
                          />
                        </div>
                      </td>
                      <td className="p-2 align-middle">{data.customer}</td>
                      <td className="p-2 align-middle text-end text-muted">
                        {data.source}
                      </td>
                      <td className="p-2 align-middle text-end text-muted">
                        {data.outbound}
                      </td>
                      <td className="p-2 align-middle text-end">
                        <BadgeStatusPrListInbounds text={data.status} />
                      </td>
                      <td className="p-2 align-middle text-end">
                        {data.delivery_date
                          ? convertDateWithoutTime(data.delivery_date)
                          : '-'}
                      </td>
                      <td className="p-2 align-middle text-end">
                        <TableAction>
                          <Button
                            variant="light"
                            className="btn-sm border rounded text-secondary"
                            style={{
                              width: '32px',
                              height: '32px',
                              padding: 0
                            }}
                            onClick={() => {
                              navigateToDetail(data)
                            }}
                          >
                            <Search size={13} />
                          </Button>
                        </TableAction>
                      </td>
                    </tr>
                  ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={8} className="p-3 border-top-0">
                    <TablePagination
                      meta={meta}
                      handlePageChange={handlePageChange}
                      handleOnChangeMeta={handleOnChangeMeta}
                    />
                  </td>
                </tr>
              </tfoot>
            </Table>
          </Col>
        </Row>
      </Container>
      <Toaster />
    </>
  )
}

export default SJ
